module.exports = __webpack_public_path__ + "img/wake.c527b04103b1e5be8cb66ef40a0218e5.jpg";